;(function (Wishlist, $) {

    var $wishlistButton = $('.wishlist-btn');
    var $wishlistTile = $('.wishlist-tile-container');
    var numProductTiles = $wishlistTile.length;
    var wishlist = localStorage.getItem('user_wishlist') || [];
    if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
    }

    /*
     * Update button to show current state (gold for active)
     */
    var animateWishlist = function (self) {
        $(self).toggleClass('is-active');
    };

    /*
     * Add/Remove selected item to the user's wishlist array in localStorage
     * Wishlist button class 'is-active' determines whether or not to add or remove
     * If 'is-active', remove the item, otherwise add it
     */
    var updateWishlist = function (self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('is-active');
        /* Remove */
        if (isRemove) {
            var removeIndex = wishlist.indexOf(productHandle);
            wishlist.splice(removeIndex, 1);
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        }
        /* Add */
        else {
            wishlist.push(productHandle);
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        }
        // console.log(JSON.stringify(wishlist));
    };

    /*
     * Loop through wishlist buttons and activate any items that are already in user's wishlist
     * Activate by adding class 'is-active'
     * Run on initialization
     */
    var activateItemsInWishlist = function () {
        $wishlistButton.each(function () {
            var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) > -1) {
                $(this).addClass('is-active');
            }
        });
    };

    /*
     * Loop through product titles and remove any that aren't a part of the wishlist
     * Decrement numProductTiles on removal
     */
    var displayOnlyWishlistItems = function () {
        $.each(wishlist, function (k, v) {
            $.getJSON('/products/' + v + '/products.json', function (response) {
                // console.log(response);
                var html = '',
                    product = response['product'],
                    id = product['id'],
                    title = product['title'],
                    image = product['image']['src'],
                    price = product['variants'][0]['price'],
                    url = '/products/' + product['handle'];
                html += '<div class="product-tile-container wishlist-tile-container" data-product-id="' + id + '">\n' +
                    '    <div class="product-tile wishlist-tile">\n' +
                    '        <div class="product-tile--tile-media">\n' +
                    '            <a class="tile-media--media-link" href="' + url + '">\n' +
                    '                <div class="media-link--image" style="background-image: url(' + image + ')">\n' +
                    '                    <img class="image--main" src="' + image + '" alt="' + title + '" style="display: none">\n' +
                    '                </div>\n' +
                    '            </a>\n' +
                    '        </div>\n' +
                    '        <div class="product-tile--tile-content">\n' +
                    '            <div class="tile-content--text">\n' +
                    '                <p class="text--title black">' + title + '</p>\n' +
                    '                <p class="text--price">$' + price + '</p>\n' +
                    '            </div>\n' +
                    '    </div>\n' +
                    '    <a class="i8b-position-fixed" href="' + url + '" title="' + title + '"></a>\n' +
                    '</div>\n' +
                    '</div>';
                $('.wishlist-grid--js').append(html);
            });
        });
        $('.wishlist-loader').fadeOut(1000, function () {
            $('.wishlist-grid').addClass('is_visible');
            $('.wishlist-hero').addClass('is_visible');
        });
        // wishlist.each(function () {
        //     var productHandle = $(this).attr('data-product-handle');
        //     if (wishlist.indexOf(productHandle) === -1) {
        //         $(this).remove();
        //         numProductTiles--;
        //     }
        // });
    };

    /*
     * Check if on the wishlist page and hide any items that aren't a part of the wishlist
     * If no wishlist items exist, show the empty wishlist notice
     */
    var loadWishlist = function () {
        if (window.location.href.indexOf('pages/wishlist') > -1) {
            displayOnlyWishlistItems();
            if (wishlist.length) {
                $('.wishlist-grid--empty-list').remove();
            } else {
                $('.wishlist-grid--empty-list').addClass('is_visible');
            }
        }
    };

    var resultload = function () {
        $("#resultLoading").show();

        setTimeout(function () {
            $("#resultLoading").hide();
        }, 1000)
    };

    var bindUIActions = function () {
        $wishlistButton.click(function (e) {
            e.preventDefault();
            updateWishlist(this);
            animateWishlist(this);
            resultload();
        });
    };

    Wishlist.init = function () {
        bindUIActions();
        activateItemsInWishlist();
        loadWishlist();
    };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
